<div
  class="start-container d-flex flex-column align-items-center justify-content-center text-center pb-10"
>
  <div
    class="w-100 gap-20 flex-grow-1 d-flex flex-column align-items-center justify-content-center"
  >
    <div
      class="flex-grow-1 w-100 d-flex flex-column align-items-center justify-content-space-evenly"
      [@fadeAnimation]
    >
      <div class="d-flex flex-column align-items-center justify-content-center gap-20">
        @if (isBadgeShown) {
          <div class="d-flex gap-8">
            <div
              class="hint-pane d-flex align-items-center justify-content-center orange"
              [@fadeAnimation]
            >
              <i class="ri-voice-ai-fill"></i>
              <span i18n="@@aiPowered">AI-powered</span>
            </div>
            <div
              class="hint-pane d-flex align-items-center justify-content-center blue"
              [@fadeAnimation]
            >
              <i class="ri-time-line"></i>
              <span i18n="@@twoMinQuiz">2-min quiz</span>
            </div>
          </div>
        }
        <app-text-player
          [hasTitle]="true"
          [fullText]="fullText"
          [audioFile]="audioFile"
          [markups]="markups"
          (audioProgressed)="onAudioProgressed($event)"
        ></app-text-player>
      </div>
    </div>

    <div class="sticky-container mt-10 w-100 pb-10" [@fadeAnimation]>
      <button
        mat-flat-button
        class="tagus w-100"
        [disabled]="!isButtonEnabled && hasStartedPlayback"
        [class.pulsing]="isButtonEnabled || !hasStartedPlayback"
        (click)="continueButtonClicked()"
        [innerHTML]="buttonText"
      ></button>
    </div>

    <app-mentioned-in class="w-100"></app-mentioned-in>
  </div>
</div>
